<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-dialog
    v-model="isVisible"
    persistent
    max-width="290"
  >
    <v-card>
      <v-card-text style="text-align: center;margin-top: 5px;">
        <p> {{ message }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="close()"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="error"
            :loading="loading"
            @click="confirm"
          >
            {{ btnText }}
          </v-btn>
        </v-card-actions>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isVisible: Boolean,
    loading: Boolean,
    message: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: 'حذف',
    },
  },
  setup(props, { emit }) {
    const close = () => {
      emit('close')
    }
    const confirm = () => {
      emit('confirm')
    }

    return {
      close,
      confirm,
    }
  },
}
</script>
